import tw, { styled } from 'twin.macro';

export const Container = styled.span`
  ${tw`text-light-low`};
`;

export const Underline = styled.span`
  ${tw`underline cursor-pointer text-light-high`};
`;
